import { useSubtypeKeys } from 'js/lib/hooks/useSubtypes'

export const buttonSubtypes = [
    'news',
    'blog',
    'discussion',
    'question',
    'event',
    'podcast',
    'poll',
    'wiki',
]

export const formSubtypes = ['news', 'blog', 'discussion', 'question', 'wiki']

export const groupSubtypes = [
    'news',
    'blog',
    'discussion',
    'question',
    'event',
    'podcast',
    'poll',
    'wiki',
]

// Check if subtype is supported by the layout
export function useSubtypeIsSupported(key: string, subtype: string) {
    const buttonSubtypeKeys = useSubtypeKeys(buttonSubtypes, {
        includeCustomTypes: true,
    })

    if (key === 'button') {
        return buttonSubtypeKeys.includes(subtype)
    } else if (key === 'form') {
        return formSubtypes.includes(subtype)
    } else if (key === 'group') {
        return groupSubtypes.includes(subtype)
    }
    return false
}
